import { LEVELS } from '../Const';
import { incomeStatementMapping } from './Const';

export const CKMapping = {
  sales: 'isa1',
  incomeFromFinancialAssetsRegconizedThroughProfitlossFvtpl: 'iss115',
  incomeFromSellingFinancialAssets: 'iss116',
  fvtplRevaluationGain: 'iss117',
  dividendInterestFromFvtplFinancialAssets: 'iss118',
  incomeFromHeldToMaturityInvestmentHtm: 'iss119',
  incomeFromLoansAndReceivables: 'iss120',
  incomeFromAvailableForSalesAssetsAfs: 'iss121',
  incomeFromDerivatives: 'iss122',
  revenueInBrokerageServices: 'iss42',
  revenueInUnderwritingServices: 'iss44',
  revenueInIssuanceAgencyServices: 'iss45',
  revenueInAdvisoryServices: 'iss46',
  revenueInAuctionTrustServices: 'iss48',
  revenueInSecuritiesCustodyService: 'iss47',
  revenueInSecuritiesInvestmentAndOtherInvestmentActivitives: 'iss43',
  retalIncomeFromInvestmentProperty: 'iss49',
  revenueIncomeFromAdvisoryServices: 'iss123',
  OtherRevenues: 'iss50',
  salesDeductions: 'isa2',
  netSales: 'isa3',
  costOfSales: 'isa4',
  lossFromFinancialAssetsRecognizedThroughProfitlossFvtpl: 'iss124',
  lossFromSellingFinancialAssetsFvtpl: 'iss125',
  fvtplFinancialAssetsRevaluationLoss: 'iss126',
  fvtplFinancialAssetsPurchaseTransactionCosts: 'iss127',
  lossFromHeldToMaturityInvestment: 'iss128',
  interestCostLossFromLoansAndReceivables: 'iss129',
  lossFromAvailableForSalesAssetsAfs: 'iss130',
  provisionForLossesFromMortgageAssetsUncollectibleReceivablesAndBorrowingExpenses:
    'iss168',
  lossFromDerivatives: 'iss131',
  proprietaryTradingServicesExpenses: 'iss132',
  brokerageExpenses: 'iss133',
  underwritingSecuritiesIssuanceExpenses: 'iss134',
  expensesForSecuritiesAdvisory: 'iss135',
  biddingAgentServiceExpensee: 'iss136',
  investorsSecuritiesDepositoryExpenses: 'iss137',
  expensesForFinancialAdvisoryActivities: 'iss138',
  otherExpenses: 'iss139',
  grossProfit: 'isa5',
  revenueFromFinancialActivities: 'iss141',
  realizedAndUnrealizedForeignExchangeGain: 'iss142',
  incomeFromNonFixedAccruedDividendAndInterest: 'iss143',
  gainFromDisposalsOrSalesOfInvestmentInSubsidiariesAssociatesAndJointVentures:
    'iss144',
  otherRevenueFromInvestments: 'iss145',
  financialExpenses: 'iss146',
  realizedAndUnrealizedForeignExchangeLoss: 'iss147',
  interestExpenses: 'iss148',
  lossFromDisposalsOrSalesOfInvestmentsInSubsidiariesAssociatesAndJointVentures:
    'iss149',
  provisionForLossesOnLongtermFinancialInvestement: 'iss150',
  otherInvestmentExpenses: 'iss151',
  gainlossFromJoinVentures: 'isa102',
  sellingCosts: 'iss152',
  generalAndAdminExpenses: 'isa10',
  operatingProfitloss: 'isa11',
  netOtherIncomeexpenses: 'isa14',
  otherIncome: 'isa12',
  otherExpenses_57: 'isa13',
  incomeFromInvestmentInOtherEntitiesBefore: 'isa15',
  netAccountingProfitlossBeforeTax: 'isa16',
  realizedGain: 'iss153',
  unrealizedGain: 'iss154',
  businessIncomeTaxExpenses: 'isa19',
  businessIncomeTaxCurrent: 'isa17',
  businessIncomeTaxdeferred: 'isa18',
  netProfitlossAfterTax: 'isa20',
  attributableToParentCompany: 'isa22',
  profitAfterTaxDeductedOfFunds: 'iss155',
  minorityInterests: 'isa21',
  otherComprehensiveGainLossAfterTax: 'iss164',
  gainlossFromRevaluationOfHeldMaturityInvestments: 'iss156',
  gainlossFromRevaluationOfAvailableForSalesFinancialAssets: 'iss157',
  gainlossDistributedFromInvestmentsInSubsidiariesAssociatesAndJointVentures:
    'iss158',
  gainlossFromRevaluationOfDerivatives: 'iss159',
  gainlossFromForeignExchangeDifferenceOfOverseaOperations: 'iss160',
  predistributedGainlossFromInvestmentsInSubsidiariesAssociatesAndJointVentures:
    'iss161',
  gainlossFromRevaluationOfDerivatives_76: 'iss162',
  gainlossFromRevaluationOfFixedAssetsUsingFairValueModel: 'iss163',
  comprehensiveIncomeDistributedToShareholders: 'iss165',
  comprehensiveIncomeDistributedToUncontrolledShareholders: 'iss166',
  netIncomeToCommonShare: 'iss167',
  epsBasic: 'isa23',
  epsDiluted: 'isa24',
  netProfitMargin: 'rtq29',
};

export const ISCKRows = Object.keys(CKMapping).map(key => {
  const mappingValue = CKMapping[key];
  const defaultItem = {
    id: mappingValue,
    i18nKey: `incomeStatementCK.${key}`,
    level: LEVELS.PARENT,
  };

  if (
    [
      CKMapping.salesDeductions,
      CKMapping.netSales,
      CKMapping.grossProfit,
      CKMapping.gainlossFromJoinVentures,
      CKMapping.sellingCosts,
      CKMapping.generalAndAdminExpenses,
      CKMapping.operatingProfitloss,
      CKMapping.incomeFromInvestmentInOtherEntitiesBefore,
      CKMapping.comprehensiveIncomeDistributedToShareholders,
      CKMapping.comprehensiveIncomeDistributedToUncontrolledShareholders,
    ].includes(mappingValue)
  ) {
    return defaultItem;
  }

  if (CKMapping.sales === mappingValue) {
    return {
      ...defaultItem,
      children: [
        CKMapping.incomeFromFinancialAssetsRegconizedThroughProfitlossFvtpl,
        CKMapping.incomeFromHeldToMaturityInvestmentHtm,
        CKMapping.incomeFromLoansAndReceivables,
        CKMapping.incomeFromAvailableForSalesAssetsAfs,
        CKMapping.incomeFromDerivatives,
        CKMapping.revenueInBrokerageServices,
        CKMapping.revenueInUnderwritingServices,
        CKMapping.revenueInIssuanceAgencyServices,
        CKMapping.revenueInAdvisoryServices,
        CKMapping.revenueInAuctionTrustServices,
        CKMapping.revenueInSecuritiesCustodyService,
        CKMapping.revenueInSecuritiesInvestmentAndOtherInvestmentActivitives,
        CKMapping.retalIncomeFromInvestmentProperty,
        CKMapping.revenueIncomeFromAdvisoryServices,
        CKMapping.OtherRevenues,
      ],
    };
  }

  if (
    mappingValue ===
    CKMapping.incomeFromFinancialAssetsRegconizedThroughProfitlossFvtpl
  ) {
    return {
      ...defaultItem,
      level: LEVELS.CHILD,
      children: [
        CKMapping.incomeFromSellingFinancialAssets,
        CKMapping.fvtplRevaluationGain,
        CKMapping.dividendInterestFromFvtplFinancialAssets,
      ],
    };
  }

  if (CKMapping.costOfSales === mappingValue) {
    return {
      ...defaultItem,
      children: [
        CKMapping.lossFromFinancialAssetsRecognizedThroughProfitlossFvtpl,
        CKMapping.lossFromHeldToMaturityInvestment,
        CKMapping.interestCostLossFromLoansAndReceivables,
        CKMapping.lossFromAvailableForSalesAssetsAfs,
        CKMapping.provisionForLossesFromMortgageAssetsUncollectibleReceivablesAndBorrowingExpenses,
        CKMapping.lossFromDerivatives,
        CKMapping.proprietaryTradingServicesExpenses,
        CKMapping.brokerageExpenses,
        CKMapping.underwritingSecuritiesIssuanceExpenses,
        CKMapping.expensesForSecuritiesAdvisory,
        CKMapping.biddingAgentServiceExpensee,
        CKMapping.investorsSecuritiesDepositoryExpenses,
        CKMapping.expensesForFinancialAdvisoryActivities,
        CKMapping.otherExpenses,
      ],
    };
  }

  if (
    mappingValue ===
    CKMapping.lossFromFinancialAssetsRecognizedThroughProfitlossFvtpl
  ) {
    return {
      ...defaultItem,
      level: LEVELS.CHILD,
      children: [
        CKMapping.lossFromSellingFinancialAssetsFvtpl,
        CKMapping.fvtplFinancialAssetsRevaluationLoss,
        CKMapping.fvtplFinancialAssetsPurchaseTransactionCosts,
      ],
    };
  }

  if (mappingValue === CKMapping.revenueFromFinancialActivities) {
    return {
      ...defaultItem,
      children: [
        CKMapping.realizedAndUnrealizedForeignExchangeGain,
        CKMapping.incomeFromNonFixedAccruedDividendAndInterest,
        CKMapping.gainFromDisposalsOrSalesOfInvestmentInSubsidiariesAssociatesAndJointVentures,
        CKMapping.otherRevenueFromInvestments,
      ],
    };
  }

  if (mappingValue === CKMapping.financialExpenses) {
    return {
      ...defaultItem,
      children: [
        CKMapping.realizedAndUnrealizedForeignExchangeLoss,
        CKMapping.interestExpenses,
        CKMapping.lossFromDisposalsOrSalesOfInvestmentsInSubsidiariesAssociatesAndJointVentures,
        CKMapping.provisionForLossesOnLongtermFinancialInvestement,
        CKMapping.otherInvestmentExpenses,
      ],
    };
  }

  if (mappingValue === CKMapping.netOtherIncomeexpenses) {
    return {
      ...defaultItem,
      children: [CKMapping.otherIncome, CKMapping.otherExpenses_57],
    };
  }

  if (mappingValue === CKMapping.netAccountingProfitlossBeforeTax) {
    return {
      ...defaultItem,
      children: [CKMapping.realizedGain, CKMapping.unrealizedGain],
    };
  }

  if (mappingValue === CKMapping.businessIncomeTaxExpenses) {
    return {
      ...defaultItem,
      children: [
        CKMapping.businessIncomeTaxCurrent,
        CKMapping.businessIncomeTaxdeferred,
      ],
    };
  }

  if (mappingValue === CKMapping.netProfitlossAfterTax) {
    return {
      ...defaultItem,
      children: [
        CKMapping.attributableToParentCompany,
        CKMapping.profitAfterTaxDeductedOfFunds,
        CKMapping.minorityInterests,
      ],
    };
  }

  if (mappingValue === CKMapping.otherComprehensiveGainLossAfterTax) {
    return {
      ...defaultItem,
      children: [
        CKMapping.gainlossFromRevaluationOfHeldMaturityInvestments,
        CKMapping.gainlossFromRevaluationOfAvailableForSalesFinancialAssets,
        CKMapping.gainlossDistributedFromInvestmentsInSubsidiariesAssociatesAndJointVentures,
        CKMapping.gainlossFromRevaluationOfDerivatives,
        CKMapping.gainlossFromForeignExchangeDifferenceOfOverseaOperations,
        CKMapping.predistributedGainlossFromInvestmentsInSubsidiariesAssociatesAndJointVentures,
        CKMapping.gainlossFromRevaluationOfDerivatives_76,
        CKMapping.gainlossFromRevaluationOfFixedAssetsUsingFairValueModel,
      ],
    };
  }

  if (mappingValue === CKMapping.netIncomeToCommonShare) {
    return {
      ...defaultItem,
      children: [CKMapping.epsBasic, CKMapping.epsDiluted],
    };
  }

  if (
    [
      CKMapping.lossFromSellingFinancialAssetsFvtpl,
      CKMapping.fvtplFinancialAssetsRevaluationLoss,
      CKMapping.fvtplFinancialAssetsPurchaseTransactionCosts,
      CKMapping.incomeFromSellingFinancialAssets,
      CKMapping.fvtplRevaluationGain,
      CKMapping.dividendInterestFromFvtplFinancialAssets,
    ].includes(mappingValue)
  ) {
    return {
      ...defaultItem,
      level: LEVELS.THREE,
    };
  }

  return {
    ...defaultItem,
    level: LEVELS.CHILD,
  };
});
